export default __webpack_public_path__ + "static/media/card-badges.cfa8d16b.jpg";